module.exports = __webpack_public_path__ + "static/rozpuszczalne_puszka-58cc642cccd950ce27e78d2e2ae12d6e.png";